var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { theme as defaultTheme, } from '@kareo/design-system';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
/**
 * Gets the resulting theme overrides object, which optionally consists each of the override types (palette, overrides, typography)
 * If provided, each override type is a merge of the base theme's property values with the override values.
 * @param theme the base theme
 * @param themeOverrides the local theme overrides for customizations (may include palette, overrides, typography)
 * @returns the merged overrides
 */
export var getThemeOverrides = function (theme, themeOverrides) {
    var palette = themeOverrides.palette, overrides = themeOverrides.overrides, typography = themeOverrides.typography;
    return __assign(__assign(__assign({}, (!!palette && { palette: __assign(__assign({}, theme.palette), palette) })), (!!overrides && { overrides: __assign(__assign({}, theme.overrides), overrides) })), (!!typography && { typography: __assign(__assign({}, theme.typography), typography) }));
};
/**
 * Gets the Design System theme created using the base theme and applying its (optional) theme overrides
 * @param themeOverrides the local theme overrides for customizations (may include palette, overrides, typography)
 * @returns the Design System theme
 */
export var getDesignSystemTheme = function (themeOverrides) {
    var theme = themeOverrides ? createMuiTheme(defaultTheme, getThemeOverrides(defaultTheme, themeOverrides)) : defaultTheme;
    return theme;
};
export default getDesignSystemTheme;
